import React, { PropsWithChildren } from 'react';

import classes from './main-layout.module.css';

export interface MainLayoutProps {}

export const MainLayout: React.FC<PropsWithChildren<MainLayoutProps>> = ({
  children,
}) => {
  return (
    <main className={classes.main}>
      <section className={classes.content}>
        <div className="w-100">{children}</div>
      </section>
    </main>
  );
};
